<script lang="ts">
    import type {Snippet} from 'svelte';
    import LogoLoginSettings from '$lib/components/_page/LogoLoginSettings.svelte';
    import NavLinks from '$lib/components/_page/NavLinks.svelte';
    import LoadingScreen from '$lib/components/LoadingScreen.svelte';
    import PageWrapper from '$lib/components/_page/PageWrapper.svelte';

    interface Props {
        setup: Promise<void>;
        awaitSetup: boolean;
        loggedIn: boolean;
        sidebar?: Snippet;
        page: Snippet
    }

    // prettier-ignore
    let {
        setup,
        awaitSetup,
        loggedIn,
        sidebar,
        page
    }: Props = $props()
</script>

<div id="page">
    <LogoLoginSettings
            setup={setup}
            loggedIn={loggedIn}
    />

    <NavLinks/>

    {#if awaitSetup}
        {#await setup then _}
            {@render sidebar?.()}
        {/await}
    {:else}
        {@render sidebar?.()}
    {/if}

    <main>
        {#if awaitSetup}
            {#await setup}
                <LoadingScreen/>
            {:then _ }
                {@render page()}
            {:catch _}
                <PageWrapper footer={true}>
                    <h1>Oops!</h1>
                    <p>
                        Something went wrong. Please try again or contact support@vocabeo.com if the problem persists.
                    </p>
                </PageWrapper>
            {/await}
        {:else}
            {@render page()}
        {/if}
    </main>
</div>

<style>
    #page {
        position: relative;
        width: 100%;
        height: 100%;
        display: grid;
        grid-template-columns: 1.2rem 230px 1.2rem 1fr;
        grid-template-rows: min-content min-content 1fr;
        grid-template-areas:
                ". logo   . main"
                ". nav    . main"
                ". filter . main";
    }

    main {
        grid-area: main;
        position: relative;
        display: flex;
        flex-direction: column;
        height: 100%;
    }

    @media (max-width: 1000px) {
        #page {
            grid-template-columns: 100%;
            --logo-height: 3.3rem;
            --nav-height: 3.3rem;
            grid-template-rows: var(--logo-height) calc(100% - var(--logo-height) - var(--nav-height)) var(--nav-height);
            grid-template-areas:
                    "logo"
                    "main"
                    "nav";
        }
    }
</style>